/* lg-details-scroll.js (31 Aug): the product-info column is position:sticky
   and taller than the viewport, so once pinned, an opening <details> grows the
   column upward from the viewer's anchor. On open, scroll the panel's summary
   to just below the sticky header so content reveals downward. */
(function () {
  "use strict";
  var HEADER_OFFSET = 120;
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || d.tagName !== "DETAILS" || !d.classList.contains("lg-details") || !d.open) return;
    var s = d.querySelector("summary") || d;
    var y = s.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, true);
})();
